export default __webpack_public_path__ + "static/media/consueg_esign.ffea8343.pdf";